export const travelStates = [
  'TRAVEL_WAITING',
  'TRAVEL_SENT',
  'TRAVEL_VIEWED',
  'TRAVEL_STARTED',
  'TRAVEL_FINISHED',
]
